/** biome-ignore-all lint/suspicious/noExplicitAny: any type */
import type { QueryClientConfig, UseMutationOptions } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';

const defaultOptions: QueryClientConfig['defaultOptions'] = {
  queries: {
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: true,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 15,
    retry: (failureCount, error: any) => {
      if (error?.status >= 400 && error?.status < 500) {
        return false;
      }
      return failureCount < 1;
    },
  },
  mutations: {
    retry: 0,
    onError: (error) => {
      console.error('Mutation Error:', error);
    },
  },
};

export const queryClient = new QueryClient({ defaultOptions });

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> = Awaited<
  ReturnType<FnType>
>;

export type QueryConfig<T extends (...args: any[]) => any> = Omit<
  ReturnType<T>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<MutationFnType extends (...args: any) => Promise<any>> =
  UseMutationOptions<ApiFnReturnType<MutationFnType>, Error, Parameters<MutationFnType>[0]>;
